// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./assets/logo-infocert-positivo-no-border.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".ic1-header-logo-new[data-v-53ddd681]{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")!important;background-repeat:no-repeat;background-size:cover;height:2.5rem;width:5.6rem}", ""]);
// Exports
module.exports = exports;
